import React from 'react';

export function Logo({ className = "w-8 h-8" }: { className?: string }) {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      {/* Head */}
      <rect 
        x="6" 
        y="4" 
        width="12" 
        height="16" 
        rx="2" 
        stroke="currentColor" 
        strokeWidth="2"
      />
      
      {/* Eyes */}
      <circle 
        cx="9" 
        cy="10" 
        r="1.5" 
        fill="currentColor"
      />
      <circle 
        cx="15" 
        cy="10" 
        r="1.5" 
        fill="currentColor"
      />
      
      {/* Smile */}
      <path
        d="M9 14h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Antenna */}
      <path
        d="M12 4V2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Side connectors */}
      <path
        d="M4 10h2M18 10h2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}